import { render, staticRenderFns } from "./allNews.vue?vue&type=template&id=3dc16cba&scoped=true"
import script from "./allNews.vue?vue&type=script&lang=js"
export * from "./allNews.vue?vue&type=script&lang=js"
import style0 from "./allNews.vue?vue&type=style&index=0&id=3dc16cba&prod&lang=scss&scoped=true"
import style1 from "./allNews.vue?vue&type=style&index=1&id=3dc16cba&prod&scoped=true&lang=css"
import style2 from "./allNews.vue?vue&type=style&index=2&id=3dc16cba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc16cba",
  null
  
)

export default component.exports